import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/content";

const shortcuts = [
  {
    to: categoryMeta["film-info"].path,
    name: categoryMeta["film-info"].name,
    desc: "剧情脉络、人物关系与主题深度解析",
    image: categoryMeta["film-info"].image,
    icon: "ri-film-line",
    tone: "primary" as const,
  },
  {
    to: categoryMeta["related-info"].path,
    name: categoryMeta["related-info"].name,
    desc: "幕后花絮、演员动态与同类影片推荐",
    image: categoryMeta["related-info"].image,
    icon: "ri-live-line",
    tone: "accent" as const,
  },
  {
    to: "/guide",
    name: "观影指南",
    desc: "观影须知、推荐时机与影评精选",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20scene%20with%20a%20bowl%20of%20popcorn%20and%20a%20remote%20on%20a%20soft%20blanket%2C%20warm%20lamp%20light%2C%20muted%20blue-gray%20and%20orange%20palette%2C%20editorial%20photography%2C%20no%20text%2C%20inviting%20mood&width=900&height=640&seq=momfilmcatguide&orientation=landscape",
    icon: "ri-guide-line",
    tone: "secondary" as const,
  },
];

export default function CategoryShortcuts() {
  const toneClass = {
    primary: "bg-primary-100 text-primary-800",
    accent: "bg-accent-100 text-accent-800",
    secondary: "bg-secondary-200 text-secondary-900",
  };

  return (
    <section className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {shortcuts.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
        >
          <div className="relative h-32 w-full overflow-hidden bg-background-200">
            <img
              src={item.image}
              alt={item.name}
              title={item.name}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent"></div>
          </div>
          <div className="flex flex-1 items-start gap-3 p-4">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md ${toneClass[item.tone]}`}>
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
              <p className="mt-1 text-sm text-foreground-600">{item.desc}</p>
            </div>
            <i className="ri-arrow-right-up-line ml-auto mt-1 text-foreground-400 transition-colors group-hover:text-primary-600"></i>
          </div>
        </Link>
      ))}
    </section>
  );
}